console.log("Comparison Data Loaded");

const CATEGORY_COMPARISON = {

    bulb_camera: {

        title: "Bulb Camera",

        installation: "Very Easy (Bulb Socket)",

        coverage: "Single Room",

        outdoor: "No",

        wifi: "Required",

        nightVision: "Yes",

        bestFor: "Home, Apartment"

    },

    outdoor_camera: {

        title: "Outdoor Camera",

        installation: "Wall Mount",

        coverage: "Large Area",

        outdoor: "Yes",

        wifi: "WiFi / Ethernet / 4G",

        nightVision: "Yes",

        bestFor: "Garden, Shop, Office"

    },

    ptz_camera: {

        title: "PTZ Camera",

        installation: "Wall Mount",

        coverage: "360°",

        outdoor: "Yes",

        wifi: "WiFi / Ethernet",

        nightVision: "Yes",

        bestFor: "Warehouse, Villa"

    },

    fingerprint_lock: {

        title: "Fingerprint Lock",

        installation: "Door",

        coverage: "-",

        outdoor: "-",

        wifi: "Optional",

        nightVision: "-",

        bestFor: "Home, Office"

    }

};